var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.noframe?'noframe':'content'},[_c('keep-alive',[_c(_vm.page,{ref:"page",tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }